import { Language } from '@/context/LanguageContext';

export const getLocalizedCityPath = (citySlug: string, language: Language): string => {
  // For English, use the default path
  if (language === 'en') {
    return `/city/${citySlug}`;
  }
  
  // For other languages, use the localized path pattern
  return `/${language}/city/${citySlug}`;
};

export const isLocalizedCityPath = (pathname: string): { isLocalized: boolean; language?: Language; citySlug?: string } => {
  // Check for localized pattern: /lang/city/slug
  const localizedMatch = pathname.match(/^\/([a-z]{2})\/city\/(.+)$/);
  if (localizedMatch) {
    return {
      isLocalized: true,
      language: localizedMatch[1] as Language,
      citySlug: localizedMatch[2]
    };
  }
  
  // Check for default English pattern: /city/slug
  const englishMatch = pathname.match(/^\/city\/(.+)$/);
  if (englishMatch) {
    return {
      isLocalized: true,
      language: 'en',
      citySlug: englishMatch[1]
    };
  }
  
  return { isLocalized: false };
};